/* Fantastick V7.8 – central motif catalogue, category filter and editor-only placement drafts.
   No Admin API, tokens or writes to Shopify. Saved placement_data is the source of truth. */
(function (global) {
  "use strict";
  var fields = [
    { key: "sizePercent", label: "Größenkorrektur", min: 10, max: 400, step: 1, unit: "%", fallback: 100 },
    { key: "gap", label: "Abstand zum Text", min: -50, max: 50, step: 0.5, unit: "%", fallback: 0 },
    { key: "x", label: "Horizontal korrigieren", min: -50, max: 50, step: 0.5, unit: "%", fallback: 0 },
    { key: "y", label: "Vertikal korrigieren", min: -50, max: 50, step: 0.5, unit: "%", fallback: 0 },
    { key: "rotation", label: "Drehung korrigieren", min: -180, max: 180, step: 1, unit: "°", fallback: 0 }
  ];
  function object(value) { return value && typeof value === "object" && !Array.isArray(value); }
  function copy(value) {
    return JSON.parse(JSON.stringify(value || {}), function (key, item) {
      return key === "__proto__" || key === "constructor" || key === "prototype" ? undefined : item;
    });
  }
  function values(source, target) {
    target = target || {};
    fields.forEach(function (field) {
      var raw = source && source[field.key];
      if (raw === null || raw === undefined || raw === "" || typeof raw === "boolean") return;
      var value = Number(raw);
      if (Number.isFinite(value)) target[field.key] = Math.min(field.max, Math.max(field.min, value));
    });
    return target;
  }
  function readPlacement(raw, warnings, label) {
    try {
      var data = typeof raw === "string" && raw.trim() ? JSON.parse(raw) : raw;
      if (data == null || data === "") return { data: {}, valid: true };
      if (!object(data) || (data.version != null && data.version !== 1)
        || (data.profiles != null && !object(data.profiles))) throw new Error("format");
      if (data.defaults != null && !object(data.defaults)) throw new Error("defaults");
      Object.values(data.profiles || {}).forEach(function (profile) {
        if (!object(profile) || (profile.all != null && !object(profile.all))) throw new Error("profile");
        [profile.positions, profile.layouts].forEach(function (map) {
          if (map == null) return;
          if (!object(map) || Object.values(map).some(function (value) { return !object(value); })) throw new Error("profile-map");
        });
      });
      return { data: copy(data), valid: true };
    } catch (error) {
      warnings.push("Motiv „" + label + "“: placement_data ist ungültig oder hat eine unbekannte Version. Grundwerte werden verwendet; Export ist gesperrt.");
      return { data: {}, valid: false };
    }
  }
  function imageUrl(value) {
    if (typeof value !== "string") return "";
    try {
      var url = new URL(value, "https://example.invalid");
      return url.protocol === "https:" || url.protocol === "http:" ? value : "";
    } catch (error) { return ""; }
  }
  function prepare(config, warnings) {
    warnings = warnings || [];
    var season = global.FantastickSeason;
    var legacy = (Array.isArray(config.motifs) ? config.motifs : []).filter(function (item) {
      return item && item.key && item.key !== "none" && item.imageUrl && (!season || season.motifActive(item.catalogKey || item.key, config));
    }).map(function (item) { return Object.assign({}, item, { source: "legacy", categoryKeys: ["legacy"] }); });
    var mode = config.motifSource || "legacy";
    if (mode === "legacy") return { motifs: legacy, categories: [], aliases: {} };
    var restricted = new Set();
    var entries = new Map();
    var categories = [];
    var seenCategories = new Set();
    (Array.isArray(config.motifCatalog) ? config.motifCatalog : []).forEach(function (category) {
      if (!category || !category.key || seenCategories.has(String(category.key))) return;
      seenCategories.add(String(category.key));
      if (season && !season.active(category, config)) {
        (category.motifs || []).forEach(function (m) { restricted.add(String(m.key)); });
        return;
      }
      var keys = [];
      (Array.isArray(category.motifs) ? category.motifs : []).forEach(function (raw) {
        if (!raw || !raw.key || raw.enabled === false || !imageUrl(raw.imageUrl)) return;
        if (config.productId && raw.hasProductRestriction && !(raw.allowedProductIds || []).map(String).includes(String(config.productId))) { restricted.add(String(raw.key)); return; }
        var key = String(raw.key);
        if (season && !season.motifActive(key, config)) { restricted.add(key); return; }
        if (!entries.has(key)) {
          var placement = readPlacement(raw.placementData, warnings, raw.label || key);
          entries.set(key, Object.assign({}, raw, {
            key: key, label: String(raw.label || "Motiv"), source: "metaobject",
            imageUrl: imageUrl(raw.imageUrl), thumbnailUrl: imageUrl(raw.thumbnailUrl) || raw.imageUrl,
            placementData: placement.data, placementValid: placement.valid,
            categoryKeys: [], aliasKeys: []
          }));
        }
        var entry = entries.get(key);
        if (!entry.categoryKeys.includes(String(category.key))) entry.categoryKeys.push(String(category.key));
        if (!keys.includes(key)) keys.push(key);
      });
      if (keys.length) categories.push({ key: String(category.key), label: String(category.label || "Motive"), keys: keys });
      if (category.truncated) warnings.push("Kategorie „" + category.label + "“ enthält mehr als 50 Motive. Bitte in kleinere Kategorien aufteilen.");
    });
    legacy = legacy.filter(function (item) { return entries.has(String(item.catalogKey || "")) || !restricted.has(String(item.catalogKey || "")); });
    // Explicitly linked old blocks preserve their local corrections. Never guess by title.
    var aliases = {};
    var linked = new Set();
    legacy.forEach(function (item) {
      var central = entries.get(String(item.catalogKey || ""));
      if (!central) return;
      if (linked.has(central.key)) {
        warnings.push("Mehrere alte Motivblöcke verweisen auf „" + central.label + "“. Die erste Zuordnung liefert die bisherigen Korrekturen.");
      } else {
        central.legacyAdjustment = values(item);
        linked.add(central.key);
      }
      central.aliasKeys.push(String(item.key));
      aliases[String(item.key)] = central.key;
    });
    if (!entries.size) {
      warnings.push("Keine nutzbaren Metaobjekt-Motive gefunden. Die bisherigen Motivblöcke bleiben als Rückfall aktiv.");
      return { motifs: legacy, categories: [], aliases: {} };
    }
    var motifs = Array.from(entries.values());
    if (mode === "combined") {
      var remaining = legacy.filter(function (item) { return !aliases[item.key]; });
      if (remaining.length) {
        motifs = motifs.concat(remaining);
        categories.push({ key: "legacy", label: "Weitere Motive", keys: remaining.map(function (item) { return item.key; }) });
      }
    }
    return { motifs: motifs, categories: categories, aliases: aliases };
  }
  function profileKey(context) {
    return JSON.stringify([String(context.productId || ""), String(context.productKey || "personalized_product")]);
  }
  function layoutKey(context) {
    return JSON.stringify([String(context.fit || ""), String(context.size || ""), String(context.fabric || ""), context.align === "right" ? "right" : "center"]);
  }
  function resolve(motif, context) {
    var result = {};
    fields.forEach(function (field) { result[field.key] = field.fallback; });
    values(motif, result);
    var data = motif.placementData || {};
    values(data.defaults, result);
    values(motif.legacyAdjustment, result);
    var profile = object(data.profiles) && data.profiles[profileKey(context)];
    if (object(profile)) {
      values(profile.all, result);
      values(profile.positions && profile.positions[context.align], result);
      values(profile.layouts && profile.layouts[layoutKey(context)], result);
    }
    return result;
  }
  function writePlacement(motif, context, scope, adjustment) {
    if (motif.placementValid === false) throw new Error("Ungültige Ausgangsdaten zuerst im Metaobjekt korrigieren.");
    var data = copy(motif.placementData);
    data.version = 1;
    if (!object(data.profiles)) data.profiles = {};
    var key = profileKey(context);
    if (!object(data.profiles[key])) data.profiles[key] = {};
    var profile = data.profiles[key];
    if (scope === "layout") {
      if (!object(profile.layouts)) profile.layouts = {};
      profile.layouts[layoutKey(context)] = values(adjustment);
    } else {
      if (!object(profile.positions)) profile.positions = {};
      profile.positions[context.align] = values(adjustment);
      // Deliberately replace only this position's colour exceptions, never the other position.
      Object.keys(profile.layouts || {}).forEach(function (entryKey) {
        try { if (JSON.parse(entryKey)[3] === context.align) delete profile.layouts[entryKey]; } catch (error) { /* Preserve unknown keys. */ }
      });
    }
    return data;
  }
  function exportPlacement(motif, ctx) {
    if (motif.placementValid === false) throw new Error("Ungültige Ausgangsdaten zuerst im Metaobjekt korrigieren.");
    var data = copy(motif.placementData);
    data.version = 1;
    // Include the old block's corrections in THIS product profile before unlinking it.
    if (motif.legacyAdjustment) {
      if (!object(data.profiles)) data.profiles = {};
      var key = profileKey(ctx);
      if (!object(data.profiles[key])) data.profiles[key] = {};
      var profile = data.profiles[key];
      profile.all = Object.assign({}, values(motif.legacyAdjustment), profile.all || {});
    }
    return data;
  }
  function context(instance) {
    var fabric = instance.getFabric();
    var size = instance.getSize();
    var fit = instance.getFit();
    return {
      productId: instance.config.productId, productKey: instance.config.productKey,
      fabric: fabric.calibrationKey || fabric.key, fit: fit ? fit.key : "",
      size: instance.sizeSpecificLayouts && size ? size.calibrationKey || size.key : "",
      align: instance.state.alignKey
    };
  }
  function attach(instance) {
    if (instance.motifCatalogUI) return instance.motifCatalogUI;
    var root = instance.root;
    var filter = root.querySelector("[data-fkc-motif-category]");
    var filterWrap = root.querySelector("[data-fkc-motif-categories]");
    var result = root.querySelector("[data-fkc-motif-result]");
    var more = root.querySelector("[data-fkc-motif-more]");
    var editor = instance.config.designMode ? root.querySelector("[data-fkc-motif-editor]") : null;
    var list = instance.motifCategories || [];
    var favorites = global.FantastickFavorites;
    var favoritesEnabled = !!favorites && instance.config.motifFavorites !== false;
    root.dataset.fkcMotifCatalog = list.length ? "true" : "false";
    var state = { category: "all", limit: 24, scope: "position" };
    var base = new Map();
    var dirty = new Set();
    var editorToken = "";
    var viewContext = null;
    var status, controls, output, copyButton, resetButton, scope, description, name;
    var draftKey = "fkc-motif-draft-v1:" + profileKey(context(instance));
    instance.motifs.forEach(function (motif) {
      if (motif.source === "metaobject") base.set(motif.key, copy(motif.placementData));
    });
    // Session drafts are editor-only, signature-checked and never affect shoppers.
    if (editor) {
      try {
        var drafts = JSON.parse(global.sessionStorage.getItem(draftKey) || "{}");
        instance.motifs.forEach(function (motif) {
          var draft = drafts[motif.key];
          if (motif.placementValid !== false && draft && draft.signature === JSON.stringify(base.get(motif.key))) {
            var parsed = readPlacement(draft.data, [], motif.label);
            if (parsed.valid) { motif.placementData = parsed.data; dirty.add(motif.key); }
          }
        });
      } catch (error) { /* Storage may be disabled. */ }
    }
    function saveDrafts() {
      if (!editor) return;
      var drafts = {};
      instance.motifs.forEach(function (motif) {
        if (dirty.has(motif.key)) drafts[motif.key] = { signature: JSON.stringify(base.get(motif.key)), data: motif.placementData };
      });
      try { global.sessionStorage.setItem(draftKey, JSON.stringify(drafts)); } catch (error) { /* Copy/export remains available. */ }
    }
    function refreshCategories() {
      if (!filter || !filterWrap) return;
      filter.replaceChildren();
      filterWrap.hidden = list.length === 0 && !(favoritesEnabled && favorites.getAll().length);
      var options = [{ key: "all", label: "Alle Motive" }].concat(list);
      if (instance.config.motifShowAll === false && list.length) options.shift();
      if (favoritesEnabled && favorites.getAll().length) options.unshift({ key: "favorites", label: "Meine Favoriten ♥ (" + instance.motifs.filter(function (m) { return !m.seasonUnavailable && favorites.has(m.key) && (!global.FantastickSeason || global.FantastickSeason.motifActive(m.catalogKey || m.key, instance.config)); }).length + ")" });
      options.forEach(function (category) {
        var option = document.createElement("option");
        option.value = category.key; option.textContent = category.label; filter.appendChild(option);
      });
      if (!options.some(function (c) { return c.key === state.category; })) state.category = options[0].key;
      filter.value = state.category;
    }
    refreshCategories();
    if (filter && filterWrap) {
      instance.listen(filter, "change", function () {
        if (instance.busy) return;
        state.category = filter.value; state.limit = 24;
        instance.renderMotifButtons(); instance.updateControlStates();
      });
    }
    if (favoritesEnabled) instance.listeners.push(favorites.subscribe(function () {
      refreshCategories();
      if (state.category === "favorites") instance.renderMotifButtons();
      if (global.FantastickMotifUI) global.FantastickMotifUI.sync(root);
      sync();
    }));
    if (global.FantastickSeason) instance.listeners.push(global.FantastickSeason.subscribe(instance.config, function () {
      var selected = instance.getMotif(), prepared = prepare(instance.config, []);
      var previous = new Map(instance.motifs.map(function (m) { return [m.key, m]; }));
      instance.motifs = [instance.motifs[0]].concat(prepared.motifs.map(function (m) {
        var old = previous.get(m.key);
        if (old && dirty.has(m.key)) m.placementData = old.placementData;
        if (m.source === "metaobject" && !base.has(m.key)) base.set(m.key, copy(m.placementData));
        return m;
      }));
      if (selected.key !== "none" && !instance.motifs.some(function (m) { return m.key === selected.key; })) instance.motifs.push(Object.assign({}, selected, { seasonUnavailable: true }));
      instance.motifCategories = list = prepared.categories;
      if (instance.special) { instance.special.installMotifs(); list = instance.motifCategories; }
      instance.motifEnabled = instance.motifEnabled || prepared.motifs.length > 0;
      var motifStep = root.querySelector("[data-fkc-motif-step]"); if (motifStep) motifStep.hidden = !instance.motifEnabled;
      refreshCategories(); instance.renderMotifButtons(); instance.updateControlStates();
      if (!global.FantastickSeason.motifActive(selected.catalogKey || selected.key, instance.config)) instance.setStatus("Die Saison für dein gewähltes Motiv ist beendet. Bitte wähle ein anderes Motiv oder Ohne Motiv. Deine übrige Gestaltung bleibt erhalten.", "warning");
    }));
    instance.listen(more, "click", function () {
      if (instance.busy) return;
      var shown = visibleMotifs().length;
      state.limit += 24;
      instance.renderMotifButtons(); instance.updateControlStates();
      var buttons = instance.elements.motifTrack.querySelectorAll("[data-motif-key]");
      if (buttons[shown]) buttons[shown].focus({ preventScroll: true });
    });
    function filteredMotifs() {
      return instance.motifs.filter(function (motif) {
        return motif.key !== "none" && !motif.seasonUnavailable && (!global.FantastickSeason || global.FantastickSeason.motifActive(motif.key, instance.config)) && (state.category === "favorites" ? favoritesEnabled && favorites.has(motif.key) : state.category === "all" || (motif.categoryKeys || []).includes(state.category));
      });
    }
    function visibleMotifs() { return [instance.motifs[0]].concat(filteredMotifs().slice(0, state.limit)); }
    function textStatus(message) { if (status) status.textContent = message; }
    function refreshOutput(motif) {
      if (!output) return;
      output.value = motif.placementValid === false ? "" : JSON.stringify(exportPlacement(motif, context(instance)), null, 2);
    }
    if (editor) {
      controls = editor.querySelector("[data-fkc-motif-adjustments]");
      output = editor.querySelector("[data-fkc-motif-output]");
      scope = editor.querySelector("[data-fkc-motif-scope]");
      name = editor.querySelector("[data-fkc-motif-editor-name]");
      description = editor.querySelector("[data-fkc-motif-editor-context]");
      status = editor.querySelector("[data-fkc-motif-editor-status]");
      copyButton = editor.querySelector("[data-fkc-motif-copy]");
      resetButton = editor.querySelector("[data-fkc-motif-reset]");
      instance.listen(scope, "change", function () { state.scope = scope.value; editorToken = ""; refreshEditor(); });
      instance.listen(controls, "input", function (event) {
        var input = event.target.closest("[data-fkc-motif-adjustment]");
        var motif = instance.getMotif();
        if (!input || !viewContext || motif.source !== "metaobject" || motif.placementValid === false) return;
        var definition = fields.find(function (field) { return field.key === input.dataset.fkcMotifAdjustment; });
        var number = Number(input.value);
        if (!definition || input.value === "" || !Number.isFinite(number) || number < definition.min || number > definition.max) return;
        var adjustment = resolve(motif, viewContext);
        adjustment[definition.key] = number;
        motif.placementData = writePlacement(motif, viewContext, state.scope, adjustment);
        controls.querySelectorAll('[data-fkc-motif-adjustment="' + definition.key + '"]').forEach(function (field) { if (field !== input) field.value = String(number); });
        dirty.add(motif.key); saveDrafts(); refreshOutput(motif); instance.queueLayout();
        textStatus("Live-Vorschau geändert. Noch nicht in Shopify gespeichert: JSON kopieren und im Metaobjekt speichern.");
      });
      instance.listen(copyButton, "click", async function () {
        var motif = instance.getMotif();
        if (motif.source !== "metaobject" || motif.placementValid === false) return;
        refreshOutput(motif);
        try {
          if (!global.navigator.clipboard || !global.navigator.clipboard.writeText) throw new Error("clipboard");
          await global.navigator.clipboard.writeText(output.value);
          textStatus("JSON kopiert – im Motiv „" + motif.label + "“ in Platzierungsdaten / placement_data einfügen und dort speichern. Danach die Vorschau neu laden.");
        } catch (error) {
          output.focus(); output.select();
          textStatus("Bitte den markierten Text manuell kopieren und im Metaobjekt-Feld placement_data speichern.");
        }
      });
      instance.listen(resetButton, "click", function () {
        var motif = instance.getMotif();
        if (!base.has(motif.key)) return;
        motif.placementData = copy(base.get(motif.key)); dirty.delete(motif.key); saveDrafts();
        editorToken = ""; refreshEditor(); instance.queueLayout();
      });
    }
    function refreshEditor() {
      if (!editor) return;
      var motif = instance.getMotif();
      editor.hidden = motif.source !== "metaobject";
      if (editor.hidden) { editorToken = ""; return; }
      var ctx = context(instance);
      var token = JSON.stringify([motif.key, ctx, state.scope]);
      if (token === editorToken) return;
      editorToken = token; viewContext = ctx;
      name.textContent = "Motiv-Kalibrierung: " + motif.label;
      var position = ctx.align === "right" ? "Rechts" : "Mittig";
      description.textContent = "Metaobjekt: " + (motif.handle || motif.label) + " · " + instance.config.productTitle + " · Profil: " + instance.config.productKey + " · Position: " + position
        + (state.scope === "layout" ? " · nur " + instance.getFabric().label + (ctx.fit ? " / " + ctx.fit : "") + (ctx.size ? " / " + instance.getSize().label : "") : " · alle Farben und Passformen; Farb-Ausnahmen dieser Position werden beim Ändern ersetzt.");
      controls.replaceChildren();
      var adjustment = resolve(motif, ctx);
      fields.forEach(function (field) {
        var row = document.createElement("div"); row.className = "fkc__motif-adjustment";
        var label = document.createElement("label");
        var id = "FkcMotifAdjust-" + instance.config.sectionId + "-" + field.key;
        label.htmlFor = id; label.textContent = field.label + " (" + field.unit + ")";
        var range = document.createElement("input"); var number = document.createElement("input");
        [range, number].forEach(function (input) {
          input.type = input === range ? "range" : "number"; input.min = field.min; input.max = field.max; input.step = field.step;
          input.value = adjustment[field.key]; input.dataset.fkcMotifAdjustment = field.key;
          input.disabled = motif.placementValid === false;
        });
        range.id = id; number.setAttribute("aria-label", field.label + " in " + field.unit);
        row.append(label, range, number); controls.appendChild(row);
      });
      copyButton.disabled = motif.placementValid === false;
      refreshOutput(motif);
      textStatus(motif.placementValid === false ? "Ungültige Platzierungsdaten: bitte das Metaobjekt prüfen. Export gesperrt."
        : dirty.has(motif.key) ? "Nicht gespeicherter Browser-Entwurf. JSON kopieren und im Metaobjekt speichern."
          : "Gespeicherte Werte geladen. Änderungen an den Reglern sind zunächst nur eine Vorschau.");
    }
    function sync() {
      if (filter) filter.disabled = instance.busy;
      var total = filteredMotifs().length;
      if (more) { more.hidden = total <= state.limit; more.disabled = instance.busy; }
      if (result) {
        result.hidden = !instance.motifEnabled;
        result.textContent = state.category === "favorites" && total === 0 ? "Hier sind noch keine passenden Favoriten. Tippe bei einem verfügbaren Motiv auf das Herz, um es hier wiederzufinden." : Math.min(state.limit, total) + " von " + total + " Motiven · Ausgewählt: " + instance.getMotif().label;
      }
      refreshEditor();
    }
    var ui = { visibleMotifs: visibleMotifs, sync: sync };
    instance.motifCatalogUI = ui;
    return ui;
  }
  global.FantastickMotifCatalog = {
    version: "8.0.0", prepare: prepare, resolve: resolve, writePlacement: writePlacement,
    exportPlacement: exportPlacement, context: context, profileKey: profileKey, layoutKey: layoutKey, attach: attach
  };
})(typeof window !== "undefined" ? window : globalThis);
